const uomConversionApiErrorMappings = {
  name: {
    'value cannot be same as base uom': 'Sudah terdaftar di sistem.',
    'value is not unique': 'Sudah terdaftar di sistem.',
  },
  amount: {},
  base_uom: {},
  weight: {},
  volume: {},
  price: {},
}

export default uomConversionApiErrorMappings
